<template>

    <header>
        <!--<div @click="changeMiniVariant()"></div>-->
        <div class="inner">

            <button class="hamburger" @click="$emit('toggle-menu')">
                <span></span>
                <span></span>
                <span></span>
            </button>

            <div class="container-logo">
                <img class="header-logo" src="../../assets/img/logo_bul.png">
            </div>
            <div class="container-avatar">
                <div class="avatar">{{ userInitial }}</div>
                <div class="menu_admin">
                    <ul>
                        <li @click="logout()">Logout</li>
                    </ul>

                </div>
            </div>
        </div>

    </header>

</template>




<script>

import { mapGetters } from 'vuex'

export default {
    name: 'Header',
    methods: {

        changeMiniVariant () {
            this.$store.dispatch('changeMiniVariant')
        },

        logout () {
            this.$store.dispatch('logout')
                .then(() => {
                    this.$router.replace("/login")
                })
        },

    },
    computed: {
        ...mapGetters(['miniVariant', 'user']),
        userInitial () {
            return this.user && this.user.name ? this.user.name.charAt(0).toUpperCase() : ''
        }
    },

}
</script>

